import PopupFormWrapper from "../popupFormWrapper";
import { GOALS } from "../../../../utils/tracking";

const FORM_CODE = "serviceOrder";

export default function ServiceOrder() {
  return (
    <PopupFormWrapper
      code={FORM_CODE}
      goalOpen={GOALS.serviceOrderOpen}
      goalSent={GOALS.serviceOrderSent}
      extraData={({ popupData }) =>
        popupData ? { form_text_7: popupData } : null
      }
      onSuccess={() => {
        if (
          window.location.href.includes(
            "vnesenie-izmeneniy-v-konstruktsiyu-ts-posle-ustanovki-farkopa_v_moskve",
          )
        ) {
          if (typeof ym !== "undefined") {
            // eslint-disable-next-line no-undef
            ym(20518312, "reachGoal", "mskRegFormSent");
          }
        } else if (
          window.location.href.includes(
            "vnesenie-izmeneniy-v-konstruktsiyu-ts-posle-ustanovki-farkopa_v_sankt-peterburge",
          )
        ) {
          if (typeof ym !== "undefined") {
            // eslint-disable-next-line no-undef
            ym(20518312, "reachGoal", "spbRegFormSent");
          }
        }
      }}
    />
  );
}
